module.exports = "/_next/static/images/maps-jetty-BG-cae3449d545c8f3bb5df9c2e79953c72.png";